var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBarChart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar-chart-2-24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.668 3C13.2203 3 13.668 3.44772 13.668 4V20C13.668 20.5523 13.2203 21 12.668 21C12.1157 21 11.668 20.5523 11.668 20V4C11.668 3.44772 12.1157 3 12.668 3ZM18.668 9C19.2203 9 19.668 9.44772 19.668 10V20C19.668 20.5523 19.2203 21 18.668 21C18.1157 21 17.668 20.5523 17.668 20V10C17.668 9.44772 18.1157 9 18.668 9ZM6.66797 13C7.22025 13 7.66797 13.4477 7.66797 14V20C7.66797 20.5523 7.22025 21 6.66797 21C6.11568 21 5.66797 20.5523 5.66797 20V14C5.66797 13.4477 6.11568 13 6.66797 13Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBarChart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bar-chart.db0c652c.svg";
export { ForwardRef as ReactComponent };